<div class="login-shell" [class.login-shell--cliente]="mode === 'cliente'">

  <!-- LEFT panel: form, top-left logo, left-aligned title -->
  <main class="login-shell__main">

    <!-- Top-left brand mark -->
    <a class="login-shell__brand" href="https://www.amajorsb.com" target="_blank" rel="noopener">
      <img class="login-shell__brand-logo" src="assets/logo.svg" alt="Amajor" />
    </a>

    <div class="login-shell__content">

      <!-- Success state (cliente only). In PWA iOS/iPadOS/macOS il deep-link
           email non apre la PWA, quindi subito sotto al messaggio di conferma
           rendiamo già aperto l'input del codice con la scadenza 15 min —
           niente bottone intermedio: il codice è l'unico modo per entrare. -->
      <ng-container *ngIf="success; else formBlock">
        <div class="login-shell__success">
          <div class="login-shell__success-icon" aria-hidden="true">
            <i nz-icon nzType="check-circle" nzTheme="fill"></i>
          </div>
          <h1 class="login-shell__success-title">{{ successTitle }}</h1>
          <p class="login-shell__success-subtitle">{{ successSubtitle }}</p>

          <div class="login-shell__success-code" *ngIf="isPWA">
            <label class="login-shell__field login-shell__field--code">
              <span class="login-shell__field-label">
                Inserisci il codice ricevuto via email
              </span>
              <div class="login-shell__code-wrap">
                <input
                  type="text"
                  autocomplete="one-time-code"
                  inputmode="text"
                  class="login-shell__input login-shell__input--code"
                  [(ngModel)]="enteredCode"
                  maxlength="10"
                  placeholder="ABC123"
                  [disabled]="codeCountdownExpired || codeLoading"
                  (keydown.enter)="onCodeInputSubmit()" />
                <div class="login-shell__code-timer"
                  [class.login-shell__code-timer--critical]="codeCountdownCritical"
                  [class.login-shell__code-timer--expired]="codeCountdownExpired"
                  aria-live="polite"
                  [attr.aria-label]="codeCountdownExpired ? 'Codice scaduto' : ('Scade tra ' + codeCountdown)">
                  <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                  <span>{{ codeCountdownExpired ? 'Scaduto' : codeCountdown }}</span>
                </div>
              </div>
            </label>
            <p class="login-shell__error" *ngIf="codeError" role="alert">
              {{ codeError }}
            </p>
            <p class="login-shell__code-expired" *ngIf="codeCountdownExpired" role="alert">
              Il codice è scaduto. Richiedi un nuovo link per ottenerne uno valido.
            </p>
            <button
              type="button"
              class="login-shell__cta"
              (click)="onCodeInputSubmit()"
              [disabled]="codeLoading || codeCountdownExpired">
              <i *ngIf="codeLoading" nz-icon nzType="loading" class="login-shell__cta-icon"></i>
              {{ codeLoading ? 'Verifica in corso...' : 'Accedi con codice' }}
            </button>
          </div>
        </div>
      </ng-container>

      <ng-template #formBlock>

        <!-- Loader overlay -->
        <div class="login-shell__loader" *ngIf="loading">
          <app-loader-4h size="md"></app-loader-4h>
        </div>

        <div class="login-shell__form" *ngIf="!loading">

          <!-- Reset password view (from /recupera/:code) -->
          <ng-container *ngIf="resetView">

            <!-- Reset success -->
            <ng-container *ngIf="resetSuccess; else resetFormBlock">
              <div class="login-shell__success">
                <div class="login-shell__success-icon" aria-hidden="true">
                  <i nz-icon nzType="check-circle" nzTheme="fill"></i>
                </div>
                <h1 class="login-shell__success-title">Password aggiornata</h1>
                <p class="login-shell__success-subtitle">
                  La tua password è stata reimpostata con successo.
                  Ora puoi accedere con le nuove credenziali.
                </p>
                <div class="login-shell__footer">
                  <a class="login-shell__recover-link" routerLink="/admin/login">
                    Vai al login
                  </a>
                </div>
              </div>
            </ng-container>

            <!-- Reset error (invalid/expired code) -->
            <ng-template #resetFormBlock>
              <ng-container *ngIf="resetError; else resetFields">
                <div class="login-shell__success">
                  <div class="login-shell__success-icon login-shell__success-icon--error" aria-hidden="true">
                    <i nz-icon nzType="close-circle" nzTheme="fill"></i>
                  </div>
                  <h1 class="login-shell__success-title">Link non valido</h1>
                  <p class="login-shell__success-subtitle">{{ resetError }}</p>
                  <div class="login-shell__footer">
                    <a class="login-shell__recover-link" routerLink="/admin/login">
                      Torna al login
                    </a>
                  </div>
                </div>
              </ng-container>

              <!-- Reset password fields -->
              <ng-template #resetFields>
                <header class="login-shell__heading">
                  <h1 class="login-shell__title">
                    Nuova password<span class="login-shell__title-dot">.</span>
                  </h1>
                  <p class="login-shell__subtitle">
                    Scegli una nuova password per il tuo account.
                    Deve contenere almeno 8 caratteri.
                  </p>
                </header>

                <div class="login-shell__fields">
                  <label class="login-shell__field">
                    <span class="login-shell__field-label">Nuova password</span>
                    <div class="login-shell__password">
                      <input
                        [type]="isPasswordVisible ? 'text' : 'password'"
                        autocomplete="new-password"
                        class="login-shell__input"
                        [(ngModel)]="newPassword"
                        placeholder="Minimo 8 caratteri"
                        (keydown.enter)="onResetSubmit()" />
                      <button
                        type="button"
                        class="login-shell__password-toggle"
                        (click)="togglePasswordVisibility()"
                        [attr.aria-label]="isPasswordVisible ? 'Hide password' : 'Show password'">
                        <i nz-icon [nzType]="isPasswordVisible ? 'eye-invisible' : 'eye'"></i>
                      </button>
                    </div>
                  </label>

                  <label class="login-shell__field">
                    <span class="login-shell__field-label">Conferma password</span>
                    <input
                      type="password"
                      autocomplete="new-password"
                      class="login-shell__input"
                      [(ngModel)]="confirmPassword"
                      placeholder="Ripeti la password"
                      (keydown.enter)="onResetSubmit()" />
                  </label>
                </div>

                <p class="login-shell__error" *ngIf="resetFormError || resetSaveError" role="alert">
                  {{ resetFormError || resetSaveError }}
                </p>

                <button
                  type="button"
                  class="login-shell__cta"
                  (click)="onResetSubmit()">
                  Salva password
                </button>
              </ng-template>
            </ng-template>

          </ng-container>

          <!-- Code-entry view (PWA fallback quando il magic-link non può
               deep-link nella PWA, es. iOS standalone). -->
          <ng-container *ngIf="codeView && !recoverView && !resetView">
            <header class="login-shell__heading">
              <h1 class="login-shell__title">
                Inserisci il codice<span class="login-shell__title-dot">.</span>
              </h1>
              <p class="login-shell__subtitle">
                Incolla o digita il codice che hai ricevuto via email per accedere.
              </p>
            </header>

            <div class="login-shell__fields">
              <label class="login-shell__field">
                <span class="login-shell__field-label">Codice</span>
                <input
                  type="text"
                  autocomplete="one-time-code"
                  inputmode="text"
                  class="login-shell__input login-shell__input--code"
                  [(ngModel)]="enteredCode"
                  maxlength="10"
                  placeholder="ABC123"
                  (keydown.enter)="onCodeInputSubmit()" />
              </label>
            </div>

            <p class="login-shell__error" *ngIf="codeError" role="alert">
              {{ codeError }}
            </p>

            <button
              type="button"
              class="login-shell__cta"
              (click)="onCodeInputSubmit()"
              [disabled]="codeLoading">
              <i *ngIf="codeLoading" nz-icon nzType="loading" class="login-shell__cta-icon"></i>
              {{ codeLoading ? 'Verifica in corso...' : 'Accedi con codice' }}
            </button>

            <div class="login-shell__footer">
              <a class="login-shell__recover-link" (click)="backToLogin()">
                <i nz-icon nzType="arrow-left" class="login-shell__back-icon"></i>
                Torna al login
              </a>
            </div>
          </ng-container>

          <!-- Login view -->
          <ng-container *ngIf="!codeView && !recoverView && !resetView">
            <header class="login-shell__heading">
              <h1 class="login-shell__title">
                {{ 'login' | translate }}
                <span class="login-shell__title-dot">.</span>
              </h1>
              <p class="login-shell__subtitle" [innerHTML]="'descriptionText' | translate"></p>
            </header>

            <div class="login-shell__fields">

              <label class="login-shell__field">
                <span class="login-shell__field-label">Email</span>
                <input
                  type="email"
                  autocomplete="username"
                  class="login-shell__input"
                  [(ngModel)]="username"
                  [placeholder]="'placeHolderUsername' | translate"
                  (blur)="onUsernameBlur()"
                  (keydown.enter)="onFormSubmit()" />
              </label>

              <label class="login-shell__field" *ngIf="mode === 'admin'">
                <span class="login-shell__field-label">Password</span>
                <div class="login-shell__password">
                  <input
                    [type]="isPasswordVisible ? 'text' : 'password'"
                    autocomplete="current-password"
                    class="login-shell__input"
                    [(ngModel)]="password"
                    placeholder="Password"
                    (keydown.enter)="onFormSubmit()" />
                  <button
                    type="button"
                    class="login-shell__password-toggle"
                    (click)="togglePasswordVisibility()"
                    [attr.aria-label]="isPasswordVisible ? 'Hide password' : 'Show password'">
                    <i nz-icon [nzType]="isPasswordVisible ? 'eye-invisible' : 'eye'"></i>
                  </button>
                </div>
              </label>

            </div>

            <a class="login-shell__forgot" *ngIf="showRecover" (click)="showRecoverView()">
              Password dimenticata?
            </a>

            <p class="login-shell__error" *ngIf="formError || error" role="alert">
              {{ error || ('wrongLogin' | translate) }}
            </p>

            <button
              type="button"
              class="login-shell__cta"
              (click)="onFormSubmit()"
              [disabled]="loading">
              {{ (mode === 'admin' ? 'login' : 'sendPassword') | translate }}
            </button>


            <button
              *ngIf="canInstall$ | async"
              type="button"
              class="install-card"
              (click)="onInstallClick()"
              aria-label="Installa l'app Amajor 4H">
              <span class="install-card__icon install-card__icon--tile">
                <img src="/assets/pwa/icon-192.png" alt="" class="install-card__tile-img" />
              </span>
              <span class="install-card__body">
                <span class="install-card__title">Installa Amajor 4H</span>
                <span class="install-card__subtitle">Accesso rapido dalla Home del tuo dispositivo</span>
              </span>
              <span class="install-card__arrow" aria-hidden="true">
                <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
              </span>
            </button>

          </ng-container>

          <!-- Recover view (admin only, replaces login form) -->
          <ng-container *ngIf="recoverView">

            <!-- Recover success -->
            <ng-container *ngIf="recoverSuccess; else recoverFormBlock">
              <div class="login-shell__success">
                <div class="login-shell__success-icon" aria-hidden="true">
                  <i nz-icon nzType="mail" nzTheme="outline"></i>
                </div>
                <h1 class="login-shell__success-title">Email inviata</h1>
                <p class="login-shell__success-subtitle">
                  Controlla la tua casella di posta per il link di reimpostazione password.
                  Se non trovi l'email, verifica nella cartella spam.
                </p>
                <div class="login-shell__footer">
                  <a class="login-shell__recover-link" (click)="backToLogin()">
                    <i nz-icon nzType="arrow-left" style="margin-right: 6px"></i>
                    Torna al login
                  </a>
                </div>
              </div>
            </ng-container>

            <!-- Recover form -->
            <ng-template #recoverFormBlock>
              <header class="login-shell__heading">
                <h1 class="login-shell__title">
                  Recupera password<span class="login-shell__title-dot">.</span>
                </h1>
                <p class="login-shell__subtitle">
                  Inserisci l'email associata al tuo account e ti invieremo
                  un link per reimpostare la password.
                </p>
              </header>

              <div class="login-shell__fields">
                <label class="login-shell__field">
                  <span class="login-shell__field-label">Email</span>
                  <input
                    type="email"
                    class="login-shell__input"
                    [(ngModel)]="recoverEmail"
                    placeholder="nome@azienda.com"
                    (keydown.enter)="onRecoverSubmit()" />
                </label>
              </div>

              <p class="login-shell__error" *ngIf="recoverError" role="alert">
                {{ recoverError }}
              </p>

              <button
                type="button"
                class="login-shell__cta"
                (click)="onRecoverSubmit()"
                [disabled]="recoverLoading">
                <i *ngIf="recoverLoading" nz-icon nzType="loading" style="margin-right: 8px"></i>
                {{ recoverLoading ? 'Invio in corso...' : 'Invia link di recupero' }}
              </button>

              <div class="login-shell__footer">
                <a class="login-shell__recover-link" (click)="backToLogin()">
                  <i nz-icon nzType="arrow-left" style="margin-right: 6px"></i>
                  Torna al login
                </a>
              </div>
            </ng-template>

          </ng-container>

        </div>
      </ng-template>

    </div>
  </main>

  <!-- RIGHT panel: brand-gradient wavy lines + floating 4H bubbles -->
  <app-login-hero></app-login-hero>
</div>

<!-- Desktop / fallback install instructions modal content -->
<ng-template #desktopInstallTpl>
  <div class="install-guide">
    <header class="install-guide__header">
      <div class="install-guide__logo">
        <img src="/assets/pwa/icon-192.png" alt="" />
      </div>
      <div>
        <h3 class="install-guide__title">Installa Amajor 4H</h3>
        <p class="install-guide__lead">Aprila come app autonoma con icona dedicata.</p>
      </div>
    </header>

    <section class="install-guide__section">
      <h4 class="install-guide__section-title">
        <i nz-icon nzType="chrome" nzTheme="outline"></i>
        Chrome / Edge / Brave — desktop
      </h4>
      <ol class="install-guide__steps">
        <li>Menu <strong>⋮</strong> in alto a destra → <strong>Cast, salva e condividi</strong> → <strong>Installa app…</strong></li>
        <li>In alternativa, clicca l'icona <i nz-icon nzType="download" nzTheme="outline"></i> nella barra degli indirizzi.</li>
        <li>Spunta <em>Crea scorciatoia sul desktop</em> e <em>Apri come finestra</em>, poi <strong>Installa</strong>.</li>
      </ol>
    </section>

    <section class="install-guide__callout">
      <i nz-icon nzType="desktop" nzTheme="outline"></i>
      <div>
        <strong>Windows / Linux:</strong> icona creata automaticamente sul desktop e nel menu Start.<br />
        <strong>macOS:</strong> la trovi in <em>Applicazioni</em> — trascinala sul Dock o sul Desktop.
      </div>
    </section>

    <section class="install-guide__section">
      <h4 class="install-guide__section-title">
        <i nz-icon nzType="android" nzTheme="outline"></i>
        Android
      </h4>
      <ol class="install-guide__steps">
        <li>Menu <strong>⋮</strong> → <strong>Installa app</strong> o <strong>Aggiungi a schermata Home</strong>.</li>
      </ol>
    </section>

    <details class="install-guide__faq">
      <summary>Non vedo l'opzione?</summary>
      <ul>
        <li><strong>Firefox/Safari desktop</strong> non supportano l'installazione — usa Chrome, Edge o Brave.</li>
        <li><strong>Navigazione privata</strong>: installazione disabilitata — apri in finestra normale.</li>
        <li>Chrome la mostra dopo qualche secondo di interazione: aspetta e riprova dal menu.</li>
        <li>Serve <strong>HTTPS</strong> (o <code>localhost</code>).</li>
      </ul>
    </details>
  </div>
</ng-template>

<!-- iOS install instructions modal content -->
<ng-template #iosInstallTpl>
  <div class="install-guide">
    <header class="install-guide__header">
      <div class="install-guide__logo">
        <img src="/assets/pwa/icon-192.png" alt="" />
      </div>
      <div>
        <h3 class="install-guide__title">Installa Amajor 4H</h3>
        <p class="install-guide__lead">Aggiungila alla schermata Home del tuo dispositivo.</p>
      </div>
    </header>

    <section class="install-guide__section">
      <h4 class="install-guide__section-title">
        <i nz-icon nzType="apple" nzTheme="outline"></i>
        iPhone / iPad — Safari
      </h4>
      <ol class="install-guide__steps">
        <li>Tocca <i nz-icon nzType="share-alt" nzTheme="outline"></i> <strong>Condividi</strong> nella barra Safari.</li>
        <li>Scorri e scegli <strong>Aggiungi alla schermata Home</strong> <i nz-icon nzType="plus-square" nzTheme="outline"></i>.</li>
        <li>Conferma con <strong>Aggiungi</strong> in alto a destra.</li>
      </ol>
    </section>

    <details class="install-guide__faq">
      <summary>Non vedo Condividi?</summary>
      <ul>
        <li>Devi usare <strong>Safari</strong> — Chrome/Firefox/Edge su iOS non permettono l'installazione.</li>
        <li>Esci dalla <strong>navigazione privata</strong> e riapri in una scheda normale.</li>
        <li>Controlla che il sito sia aperto via <strong>HTTPS</strong>.</li>
      </ul>
    </details>
  </div>
</ng-template>
